import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { Site } from '../sites';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { routeData } from '../shared/route-helpers';

@Injectable()

export class SiteRouteDataStorage {

    public readonly snapshot: {
        selectedSite: Site
    };

    public readonly selectedSite: Observable<Site>;

    constructor (activatedRoute: ActivatedRoute) {
        this.snapshot = {
            selectedSite: activatedRoute.snapshot.data[routeData.selectedSite] as Site
        };

        this.selectedSite = activatedRoute.data.pipe(
            map(data => data[routeData.selectedSite] as Site)
        );
    }
}